import React, { useEffect, useState, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Table,
  Label,
  Input,
  UncontrolledCollapse,
  CardBody,
  Tooltip,
} from "reactstrap";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import defaultAvatar from "../../../constants/Images/defaultAvatar-1.png";
import { CustomAlertMessage } from "../../../functions/CustomFunctions";
import API from "../../../redux/actions/API";
import { getAgencyId, getAgencyURL } from "../../common/CommonFunctions";
import { authHeader } from "../../../functions/CoreFunctions";
import { useSnackbar } from "notistack";
import { EMPLOYEE_LIST } from "../../../constants/ApiPaths";
import Pagination from "../../common/Pagination";
import CreateGuestUser from "./CreateGuestUser";
import { Link } from "react-router-dom";
import { debounce } from "underscore";
import { GUEST_USER_LICENSE } from "../../../constants/RoutePaths";
import { Info } from "../../common/Info";
import {  useSelector } from "react-redux";

// intial Values
const initialValues = {
  firstName: "",
  lastName: "",
  email: "",
  gender: "",
  dateOfBirth: "",
  phoneNumber: "+1 ",
  profileImage: "",
  stateId: null,
  city: "",
  address: "",
  zip: "",
  agencyUrl: getAgencyURL(),
};

export default function Poc() {
  const [loading, setLoading] = useState(false);
  const [GuestUserList, setGuestUserList] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const [currentpage, setCurrentPage] = useState(0);
  const [totalrecords, setTotalRecords] = useState(0);
  const [modal, setModal] = useState(false);
  const [flag, setflag] = useState(true);
  const [formData, setFormData] = useState(initialValues);
  const emailDisabled=false;
  const [namefilter, setnamefilter] = useState("");
  const [emailfilter, setemailfilter] = useState("");
  const [numberfilter, setnumberfilter] = useState("");
  const [id, setid] = useState("");
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const Delete = useSelector((state) => state.Agencydelete);


  const tooltiptoggle = (id) => {
    setid(id);
    setTooltipOpen(!tooltipOpen);
  };
  const resetFormData = () => {
    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      gender: "",
      dateOfBirth: "",
      phoneNumber: "+1 ",
      profileImage: "",
      stateId: null,
      city: "",
      address: "",
      zip: "",
      agencyUrl: getAgencyURL(),
    });
  };
  const toggle = () => {
    if (Delete) return;
    setModal(!modal);
    setflag(true);
    resetFormData();
  };

  const UpdateToogle = () => {
    if (Delete) return;
    setModal(!modal);
    setflag(false);
  };

  const GuestUser = async (namefilter, emailfilter, numberfilter) => {
    setLoading(true);
    const config = {
      method: "GET",
      url: EMPLOYEE_LIST,
      headers: authHeader(),
      params: {
        roleId: 6,
        agencyId: getAgencyId(),
        offset: currentpage,
        firstName: namefilter,
        email: emailfilter,
        phoneNumber: numberfilter,
      },
    };
    try {
      const response = await API(config);
      const { status, data, totalCount } = response.data;
      if (status === "Success") {
        setGuestUserList(data);
        setTotalRecords(totalCount);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
      setLoading(false);
    }
  };
  const onPageChange = (page) => {
    setCurrentPage(page - 1);
  };

  const Profile = (data) => {
    const image = data.profileImage;
    if (image) {
      return image;
    } else {
      return defaultAvatar;
    }
  };

  const UpdateGuest = (e) => {
    const Id = e.currentTarget.dataset.userid;
    const Value1 = GuestUserList.map((G) => {
      return {
        ...G,
        phoneNumber: "+1 ".concat(G.phoneNumber),
      };
    });
    const Value = Value1.filter((G) => G.userId === Id);
    setFormData(...Value1);
    UpdateToogle();
  };

  const Successfullrecall = () => {
    GuestUser();
  };
  const onHandleNameChange = (e) => {
    setnamefilter(e.target.value);
  };

  const onHandleEmailChange = (e) => {
    setemailfilter(e.target.value);
  };
  const onHandlePhoneChange = (e) => {
    setnumberfilter(e.target.value);
  };

  const clearButton = () => {
    setnamefilter("");
    setemailfilter("");
    setnumberfilter("");
  };

  const delaySearch = useRef(
    debounce((namefilter, emailfilter, numberfilter) =>
      GuestUser(namefilter, emailfilter, numberfilter)
    )
  ).current;
  useEffect(() => {
    delaySearch(namefilter, emailfilter, numberfilter);
  }, [namefilter, emailfilter, numberfilter]);

  useEffect(() => {
    GuestUser();
  }, [currentpage]);

  return (
    <div className="agency-wrapper">
      <Container fluid>
        <div className="page-title">
          <h4>
            POS Sale{" "}
            <Tooltip
              isOpen={id === "guestuser" && tooltipOpen}
              target={"guestuser"}
              toggle={() => tooltiptoggle("guestuser")}
            >
              View point of sale transaction information
            </Tooltip>
            <span id={"guestuser"}>
              <Info />
            </span>
          </h4>
          <div className="top-btn">
            <Button color="link" id="toggler">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14.371"
                height="14.371"
                viewBox="0 0 14.371 14.371"
              >
                <path
                  id="Icon_awesome-filter"
                  data-name="Icon awesome-filter"
                  d="M13.7,0H.674A.674.674,0,0,0,.2,1.15L5.389,6.342v5.784a.674.674,0,0,0,.287.552l2.246,1.571a.674.674,0,0,0,1.06-.552V6.342L14.173,1.15A.674.674,0,0,0,13.7,0Z"
                  fill="#1b3e6f"
                />
              </svg>
            </Button>

            <Button
              disabled={Delete}
              onClick={() => toggle(resetFormData)}
              color="primary"
            >
              <svg
                className="mr-3"
                xmlns="http://www.w3.org/2000/svg"
                width="12.401"
                height="12.402"
                viewBox="0 0 12.401 12.402"
              >
                <g
                  id="Icon_feather-plus"
                  data-name="Icon feather-plus"
                  transform="translate(-6.6 -6.6)"
                >
                  <path
                    id="Path_82"
                    data-name="Path 82"
                    d="M18,7.5V18.1"
                    transform="translate(-5.199)"
                    fill="none"
                    stroke="#fff"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.8"
                  />
                  <path
                    id="Path_83"
                    data-name="Path 83"
                    d="M7.5,18H18.1"
                    transform="translate(0 -5.199)"
                    fill="none"
                    stroke="#fff"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.8"
                  />
                </g>
              </svg>
              Add POS
            </Button>
          </div>
        </div>
        <UncontrolledCollapse toggler="#toggler" className="mt-4">
          <Card>
            <CardBody>
              <Row>
                <Col md="3">
                  <Label>Search Name</Label>
                  <Input
                    type="text"
                    name="name"
                    value={namefilter}
                    onChange={onHandleNameChange}
                    placeholder="Search Name"
                  />
                </Col>
                <Col md="3">
                  <Label>Search Email</Label>
                  <Input
                    type="email"
                    name="Email"
                    value={emailfilter}
                    onChange={onHandleEmailChange}
                    placeholder="Search Email"
                  />
                </Col>
                <Col md="3">
                  <Label>Search Phonenumber</Label>
                  <Input
                    type="number"
                    name="phoneNumber"
                    value={numberfilter}
                    onChange={onHandlePhoneChange}
                    placeholder="Search PhoneNumber"
                  />
                </Col>
                <Col md="3">
                  <Button color="danger" className="mt-4" onClick={clearButton}>
                    Clear
                  </Button>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </UncontrolledCollapse>
        <Card body className="mt-4">
          <Table hover responsive>
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Phone Number</th>
                <th style={{ textAlign: "center" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? <CustomPageLoading /> : ""}
              {loading ? (
                ""
              ) : GuestUserList.length === 0 ? (
                <tr>
                  <td colSpan={5}>
                    <center>No Records Found</center>
                  </td>
                </tr>
              ) : (
                GuestUserList.map((data) => (
                  <tr>
                    <td className="customer-fname">
                      <img src={Profile(data)} alt=""/>
                      {data.firstName} {data.lastName}
                    </td>
                    <td>{data.email}</td>
                    <td>{`+1 ${data.phoneNumber}`}</td>

                    <td style={{ textAlign: "center" }}>
                      <Link to={`${GUEST_USER_LICENSE}/${data.userId}`}>
                        <Button>POS</Button>
                      </Link>
                      <Button
                        data-userid={data.userId}
                        onClick={UpdateGuest}
                        disabled={Delete}
                        className="table-btn"
                        color="link"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="10.928"
                          height="10.928"
                          viewBox="0 0 10.928 10.928"
                        >
                          <path
                            id="Icon_material-mode-edit"
                            data-name="Icon material-mode-edit"
                            d="M4.5,13.148v2.276H6.776L13.49,8.711,11.214,6.434Zm10.75-6.2a.6.6,0,0,0,0-.856l-1.42-1.42a.6.6,0,0,0-.856,0L11.863,5.785,14.14,8.061,15.25,6.95Z"
                            transform="translate(-4.5 -4.496)"
                            fill="#1b3e6f"
                          />
                        </svg>
                      </Button>
                      <Link
                        to={{
                          pathname: `${"/agency/guest-details"}/${data.userId}`,
                        }}
                      >
                        <Button className="table-btn" color="link">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16.216"
                            height="10.811"
                            viewBox="0 0 16.216 10.811"
                          >
                            <path
                              id="Icon_awesome-eye"
                              data-name="Icon awesome-eye"
                              d="M16.118,9.494A9.03,9.03,0,0,0,8.108,4.5,9.031,9.031,0,0,0,.1,9.495a.911.911,0,0,0,0,.822,9.03,9.03,0,0,0,8.01,4.994,9.031,9.031,0,0,0,8.01-4.995A.911.911,0,0,0,16.118,9.494Zm-8.01,4.465a4.054,4.054,0,1,1,4.054-4.054A4.054,4.054,0,0,1,8.108,13.959Zm0-6.757a2.683,2.683,0,0,0-.713.107A1.347,1.347,0,0,1,5.512,9.193a2.7,2.7,0,1,0,2.6-1.99Z"
                              transform="translate(0 -4.5)"
                              fill="#1b3e6f"
                            />
                          </svg>
                        </Button>
                      </Link>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </Card>

        <div className="d-flex flex-row py-4 justify-content-end">
          <Pagination
            itemClass="page-item"
            linkClass="page-link"
            itemsCountPerPage={10}
            totalItemsCount={totalrecords}
            activePage={currentpage + 1}
            onChange={onPageChange}
          />
        </div>
      </Container>

      <CreateGuestUser
        modal={modal}
        toggleHelper={toggle}
        flag={flag}
        setflag={setflag}
        formData={formData}
        setFormData={setFormData}
        Successfullrecall={Successfullrecall}
        resetFormData={resetFormData}
        emailDisabled={emailDisabled}
        loading={loading}
        setLoading={setLoading}
        enqueueSnackbar={enqueueSnackbar}
      />
    </div>
  );
}
